import { render, staticRenderFns } from "./StoreShippingServices.vue?vue&type=template&id=632aa8e2&scoped=true"
import script from "./StoreShippingServices.vue?vue&type=script&lang=js"
export * from "./StoreShippingServices.vue?vue&type=script&lang=js"
import style0 from "./StoreShippingServices.vue?vue&type=style&index=0&id=632aa8e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "632aa8e2",
  null
  
)

export default component.exports